module.exports = __webpack_public_path__ + "static/media/escrever-sp.00e574a0.svg";